export const DRAWER_OPEN_WIDTH = 260;
export const DRAWER_CLOSE_WIDTH = 60;
